import { resolveApiErrorMessage } from '@/lib/errors/resolveApiErrorMessage';

export function isPhoneInvalidError(error: unknown): boolean {
  if (!error) return false;

  const messages: string[] = [];
  if (typeof error === 'string') messages.push(error);
  if (typeof error === 'object') {
    const record = error as {
      message?: unknown;
      graphQLErrors?: Array<{ message?: unknown }>;
    };
    if (typeof record.message === 'string') messages.push(record.message);
    if (Array.isArray(record.graphQLErrors)) {
      for (const gqlError of record.graphQLErrors) {
        if (gqlError && typeof gqlError.message === 'string') {
          messages.push(gqlError.message);
        }
      }
    }
  }

  const apiMessage = resolveApiErrorMessage(error);
  if (apiMessage) messages.push(apiMessage);
  return messages.some((message) => message.includes('phone_invalid'));
}
